import {Component, NgZone, OnInit} from '@angular/core';
import {MessagesService} from '../../provider/messages/messages.service';
import {StorageService} from '../../provider/storage/storage.service';
import {
	ConfigurationObject,
	FileInfoObj,
	InParamReadObject,
	InParamReadObjects, LockObject, UnlockObject
} from '../../interfaces/interfaces.regisafe';
import {AppConfig} from '../../app.config';
import {Router} from '@angular/router';
import {APP_EDIT_FOLDER, APP_ICON_PATH, APP_ROUTES} from '../../../environments/environment';
import {UserService} from '../../provider/user/user.service';
import {DateiSystemService} from '../../provider/datei-system/datei-system.service';
import {IQApiService} from '../../provider/iqapi/iqapi.service';
import {AlertController, LoadingController} from '@ionic/angular';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {FileTransfer, FileTransferObject, FileUploadOptions} from '@awesome-cordova-plugins/file-transfer/ngx';
import {FileOpener} from '@awesome-cordova-plugins/file-opener/ngx';
import {ALERT_TXT} from '../../strings/language';
import {Capacitor} from '@capacitor/core';
import {FileOpener as FileOpenerCom, FileOpenerOptions} from '@capacitor-community/file-opener'

declare let cordova: any;

@Component({
	selector: 'app-in-bearbeitung',
	templateUrl: './in-bearbeitung.page.html',
	styleUrls: ['./in-bearbeitung.page.scss'],
})
export class InBearbeitungPage implements OnInit {

	appIconPath = APP_ICON_PATH;
	public configuration: ConfigurationObject;
	userData: any;
	schriftgut = {};
	schriftgutLocked = [];
	objectCreate = Object;
	progress: any = 0;
	filecount: any = 0;
	loader: HTMLIonLoadingElement;
	alert: HTMLIonAlertElement;
	osId = 'Schriftgutverwaltung';

	constructor(private msgService: MessagesService,
				private alertCtrl: AlertController,
				private loadingCtrl: LoadingController,
				private storageService: StorageService,
				public appConfig: AppConfig,
				private router: Router,
				private userService: UserService,
				private dateiSystemService: DateiSystemService,
				private iqAPI: IQApiService,
				private errorHandling: ErrorHandlingService,
				private transfer: FileTransfer,
				private fileOpener: FileOpener,
				public zone: NgZone) {
		this.configuration = this.appConfig.getConfig();
	}

	async ngOnInit() {
	}

	async ionViewDidEnter() {
		this.getSchriftgutInWork();
	}

	/**
	 * getSchriftgutInWork()
	 *
	 * Lädt alle Schriftstücke die in Bearbeitung sind aus der Datenbank.
	 *
	 * @param event
	 */
	async getSchriftgutInWork(event?) {
		this.userData = await this.storageService.getConditions('user');
		const schriftgut = await this.storageService.getSchriftgut(this.userData.userId);

		if (!schriftgut) {
			// refresher beenden
			if (event) {
				event.target.complete();
			}
			return false;
		} else {
			this.schriftgut = schriftgut;
		}

		this.objectLockedState(this.schriftgut);
		this.getFileInfos(this.schriftgut);

		// Menüpunkt "In Bearbeitung" markieren, wenn Objekte in Bearbeitung sind
		if (this.schriftgut && Object.keys(this.schriftgut).length === 0) {
			this.msgService.sendMessage({filesInProgress: false});
		} else {
			this.msgService.sendMessage({filesInProgress: true});
		}

		// refresher beenden
		if (event) {
			event.target.complete();
		}
	}

	/**
	 * showDetail()
	 *
	 * Navigiert zur Deatil-Ansicht des Schriftstückes
	 *
	 * @param data
	 */
	async showDetail(data: any) {
		// eslint-disable-next-line no-underscore-dangle
		this.router.navigate([APP_ROUTES.detail, this.osId, this.userService.objIdAsRouteParam(data.details._ObjID)])
			.then((navigated) => {
				// do something or leave ist
			});
	}


	/**
	 * objectLockedState()
	 *
	 * prüft, ob das Schriftstück in der Datenbank als 'locked' markiert ist.
	 *
	 * @param items
	 */
	async objectLockedState(items: any) {

		this.schriftgutLocked = [];
		const userData = await this.storageService.getConditions('user');
		const lockedItems = await this.storageService.getLockedObjects();
		const userId = userData.userId;

		Object.keys(items).forEach((key) => {
			if (lockedItems[userId].includes(this.userService.objIdAsIQAPIParam(key))) {
				this.schriftgutLocked.push({locked: true});
			} else {
				this.schriftgutLocked.push({locked: false});
			}
		});

	}

	/**
	 * openFileForEdit()
	 *
	 * Datei zum Bearbeiten öffnen
	 *
	 * @param file
	 */
	async openFileForEdit(file) {

		if (Capacitor.getPlatform() === 'ios') {

			const comOptions: FileOpenerOptions = {
				filePath: file.uri,
				contentType: file.mime,
				openWithDefault: false
			}
			FileOpenerCom.open(comOptions)
				.then(() => {
					console.log('### FOCom: ');
				})
				.catch((e) => {
					console.log('### FOCom error: ', e);
				});

		} else {

			let fileOpenercomundus = null;
			try {
				fileOpenercomundus = cordova.plugins.fileOpener2comundus;
			} catch (e) {
				console.log('Lorem: ', e);
			}
			fileOpenercomundus.showOpenWithDialog(file.uri, file.mime, {
				// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
				success() {
					console.log('showOpenWithDialog');
				},
				// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
				error(e) {
					console.log('showOpenWithDialog error: ', e);
				}
			});

		}
	}

	/**
	 * viewFile()
	 *
	 * Datei in Vorschau öffnen (ohne Rechte zum Bearbeiten als Kopie)
	 *
	 * @param file
	 */
	viewFile(file) {
		try {
			const fileOpener = this.fileOpener.open(file.uri, file.type)
				.then((data) => {
					console.log('fileOpener: ', data);
				})
				.catch((e) => {
					console.log('fileOpener error: ', e);
				});
		} catch (e) {
			console.log('viewFile error: ', e);
		}
	}


	/**
	 * deleteFile()
	 *
	 * Löscht das übergebene Datei-Objekt aus der Datenbank und die zugehörige Datei vom Gerät.
	 *
	 * @param file
	 */
	async deleteFile(file) {
		const userData = await this.storageService.getConditions('user');
		const userId = userData.userId;
		const schriftgut = await this.storageService.getSchriftgut(userId);
		const deleteFile = await this.storageService.removeFileFromObjectInSchriftgut(file.objid, file.name);
		const loesche = await this.dateiSystemService.loescheDatei(file.path + '/' + file.name);

		if (loesche) {
			const inWork = await this.getSchriftgutInWork();
			// prüfen ob noch weitere Dateien in Bearbeitung sind
			// wenn nicht, Objekt wieder entsperren
			if (deleteFile[userId][file.objid].length < 1) {
				await this.removeObject(file.uri, file.objid, 0, file);
				this.msgService.sendMessage({filesInProgress: false});
				this.getSchriftgutInWork();
			}

		} else {
			this.errorHandling.errorMessage('Die Datei konnte nicht gelöscht werden.', 'toast', false);
		}
	}


	/**
	 * getFileInfos()
	 *
	 * Liest die Dateiinformationen der übergebenen Datei zu Laufzeit aus und übergibt diese
	 * an das Object 'schriftgut[obj]' (Erstellungsdatum, Bearbeitungsdatum, Dateigröße)
	 *
	 * @param schriftgut
	 */
	getFileInfos(schriftgut) {
		Object.keys(schriftgut).forEach((obj) => {
			schriftgut[obj].forEach((item) => {
				this.dateiSystemService.getFileInfo(item.path + '/' + item.name)
					.then((result) => {

						item.appCTimeOutput = this.convertTimestampToDate(item.appCTime);
						item.appMTimeOutput = this.convertTimestampToDate(result.mtime);
						item.mtime = result.mtime;
						item.size = this.userService.niceBytes(result.size);

						item.modified = item.appCTimeOutput !== item.appMTimeOutput;

					});
			});
		});
	}

	/**
	 * convertTimestampToDate()
	 *
	 * konvertiert den übergebenen Zeitstempel in ein Datum.
	 *
	 * @param timestamp
	 */
	convertTimestampToDate(timestamp): string {
		if (typeof timestamp === 'string') {
			timestamp = parseInt(timestamp, 10);
		}
		const dateObj = new Date(timestamp);
		const humanDateFormat = dateObj.toLocaleString();
		return humanDateFormat;
	}

	// https://codesandbox.io/s/convert-base64-to-file-blob-ji0ob
	/**
	 * updateObject()
	 *
	 * Die Methode prüft zuerst ob es eine Datei mit Änderungen gibt. Ist dies nicht der Fall, öffnet sich ein Dialog
	 * und der Benutzer bekommt die Möglichkeit das Schriftstück aus der Bearbeitung zu entfernen bzw. abzubrechen.
	 * Werden eine oder mehrere modifizierte Dateien gefunden, wird in der IQAPI die Funtkion OrgaManager.ReadObject
	 * aufgerufen und geprüft, ob der Zeitstempel des Objektes in der App und auf dem Server gleich sind. Sollte das
	 * nicht der Fall sein, öffnet sich ein Dialog mit einem entsprechenden Hinweis an den Benutzer. Dieser hat dann
	 * die Möglichkeit die Datei am Server zu überschreiben oder eine Kopie anzulegen (Option add: 1 | 2).
	 * Ansonsten werden alle geänderten Dateien auf den Server geladen (writeFileInLoop())
	 *
	 * @param obj
	 * @param item
	 * @param index
	 */
	async updateObject(obj, item, index?) {

		if (!this.loader) {
			this.loader = await this.loadingCtrl.create({duration: 10000});
			await this.loader.present();
		}

		const modified = this.schriftgut[obj].filter(o => o.mtime !== o.appMTime);

		// Keine modifizierte Datei vorhanden
		if (modified.length < 1) {

			let action = null;
			const alertNothingModified = await this.alertCtrl.create({
				header: ALERT_TXT.header.str00020,
				subHeader: ALERT_TXT.subHeader.str00080,
				buttons: [{
					text: ALERT_TXT.buttons.str00140,
					role: 'remove'
				}, {
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}]
			});

			this.dismissLoader();

			await alertNothingModified.present();
			await alertNothingModified.onDidDismiss().then((data) => {
				action = data.role;
			});

			if (action === 'remove') {
				this.removeObject(item.path, item.objid, index);
			}

			return false;
		}

		const objid = this.userService.objIdAsIQAPIParam(modified[0].objid);

		// BODY Object erstellen
		const body: InParamReadObject = {
			fields: '_Zeitstempel',
			osId: this.osId,
			objID: objid,
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken()
		};

		const objInfo = await this.iqAPI.orgaManagerReadObject(body)
			.toPromise()
			.catch((errorResponse) => {
				this.dismissLoader();
				this.errorHandling.handleError(errorResponse, 'InBearbeitungPage -> updateObject -> orgaManagerReadObject');
			});

		// eslint-disable-next-line no-underscore-dangle
		const zeitstempelApp = modified[0].details._Zeitstempel;
		// eslint-disable-next-line no-underscore-dangle
		const zeitstempelServer = objInfo.objDataset._Zeitstempel;

		if (zeitstempelApp !== zeitstempelServer) {
			const alertModifiedOnServer = await this.alertCtrl.create({
				header: ALERT_TXT.header.str00010,
				subHeader: ALERT_TXT.subHeader.str00090,
				buttons: [{
					text: ALERT_TXT.buttons.str00150,
					handler: () => {
						this.writeFileInLoop(modified, 1, modified[0].path, modified[0].objid);
					}
				}, {
					text: ALERT_TXT.buttons.str00160,
					handler: () => {
						this.writeFileInLoop(modified, 2, modified[0].path, modified[0].objid);
					}
				}, {
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}]
			});
			await this.dismissLoader();
			await alertModifiedOnServer.present();
		} else {
			this.writeFileInLoop(modified, 2, modified[0].path, modified[0].objid);
		}
	}

	/**
	 * removeObject()
	 *
	 * Entfernt ein Objekt (z.B. Schriftstück) aus der Bearbeitungsliste. Alle zugehörigen Ordner, Dateien
	 * und Datenbankeinträge werden vom Gerät entfernt. Danach wird das Objekt über die IQAPI Funktion
	 * 'OrgaManager.UnlockObject' entsperrt.
	 *
	 * @param path
	 * @param objid
	 * @param index
	 * @param obj
	 */
	async removeObject(path: string, objid: string, index?: number, obj?: any, origin?) {

		if (!this.loader) {
			this.loader = await this.loadingCtrl.create({duration: 10000});
			await this.loader.present();
		}
		// Ordner löschen
		const loescheOrdner = await this.dateiSystemService.loescheOrdner(path);

		// aus Datenbank entfernen
		const loescheSchriftgut = await this.storageService.removeObjectFromSchriftgut(objid);
		this.storageService.removeLockedObject(this.userService.objIdAsIQAPIParam(objid));

		// Object entsperren
		const options: UnlockObject = {
			objID: this.userService.objIdAsIQAPIParam(objid),
			osId: this.osId,
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
		};
		const unlock = await this.iqAPI.orgaManagerUnlockObject(options)
			.toPromise()
			.catch((e) => {
				console.log('unlockObject errorResponse - removeObject: ', e);
				// Fehler nicht ausgeben
				// this.errorHandling.handleError(e, 'InBearbeitungPage -> removeObject');
				this.dismissLoader();
			});

		// Update View
		this.getSchriftgutInWork();

		this.dismissLoader();
	}

	/**
	 * writeFileInLoop()
	 *
	 * Die Funktion entsperrt das Objekt am Server und lädt alle modifizierten Dateien in einer Schleife hoch.
	 * Danach wird das Objekt aus der Bearbeitung entfernt (removeObject())
	 *
	 * @param modifiedEntries
	 * @param add
	 * @param path
	 * @param objid
	 */
	async writeFileInLoop(modifiedEntries, add: number, path: string, objid: string) {

		const options: UnlockObject = {
			objID: this.userService.objIdAsIQAPIParam(objid),
			osId: this.osId,
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
		};

		const unlockObject = await this.iqAPI.orgaManagerUnlockObject(options)
			.toPromise()
			.catch((errorResponse) => {
				console.log('unlockObject errorResponse - writeFileInLoop: ', errorResponse);
				// Fehler nicht ausgeben
				// this.errorHandling.handleError(errorResponse, 'writeFileInLoop -> unlockObject');
			});

		const parameter = {
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
			osId: this.osId,
			objId: this.userService.objIdAsIQAPIParam(modifiedEntries[0].objid), // 0:0 od 123:456
			fileName: modifiedEntries[0].name,
			fileAdd: add
		};

		const url = this.configuration.iqapiEndpoint + '/OrgaManager.WriteObject';
		const fileTransfer: FileTransferObject = this.transfer.create();
		const transferOption: FileUploadOptions = {
			fileKey: 'binary',
			fileName: modifiedEntries[0].name,
			mimeType: modifiedEntries[0].mimeType,
			httpMethod: 'POST',
			chunkedMode: false,
			params: parameter
		};

		fileTransfer.onProgress((progressEvent) => {
			if (progressEvent.lengthComputable) {
				// eslint-disable-next-line max-len
				this.progress = Math.floor(progressEvent.loaded / progressEvent.total * 100) + '% / ' + this.userService.niceBytes(progressEvent.loaded);
				this.filecount = modifiedEntries.length;
				this.loader.message = this.filecount + ' / ' + this.progress;
				this.zone.run(() => {
				});
			} else {
				console.log('progressEvent.lengthComputable: ', progressEvent.lengthComputable);
			}

		});

		fileTransfer.upload(modifiedEntries[0].uri, url, transferOption, true)
			.catch((e) => {
				console.log('fileTransfer.upload error: ', e);
				const errorResponse = {
					error: JSON.parse(e.body)
				};
				this.dismissLoader();
				this.errorHandling.handleError(errorResponse, 'InBearbeitungPage -> writeFileInLoop -> fileTransfer.upload');
			})
			.then(async (result: any) => {
				console.log('transferObj result: ', result);
				if (!result) {
					console.log('Fehler beim Upload!!!');
					this.progress = 0;
					this.filecount = 0;
					return false;
				}

				modifiedEntries.splice(0, 1);

				if (modifiedEntries.length > 0) {
					this.writeFileInLoop(modifiedEntries, add, path, objid);
				} else {
					this.progress = 0;
					this.filecount = 0;
					await this.removeObject(path, objid);

					this.dismissLoader();
					// Update View
					this.getSchriftgutInWork();
				}
			});
	}

	back() {

	}

	/**
	 * getFileIcon()
	 *
	 * Gibt das zur Datei gehörige Icon zurück
	 *
	 * @param filename
	 */
	public getFileIcon(filename: string): any {
		const extension = filename.split('.').pop();

		const iconList: any = {};
		iconList.default = ['far', 'file-lines'];

		iconList.doc = ['far', 'file-word'];
		iconList.docx = ['far', 'file-word'];
		iconList.xls = ['far', 'file-excel'];
		iconList.xlsx = ['far', 'file-excel'];

		iconList.rtf = ['far', 'file-lines'];
		iconList.txt = ['far', 'file-lines'];

		iconList.pdf = ['far', 'file-pdf'];

		iconList.jpg = ['far', 'file-image'];
		iconList.jpeg = ['far', 'file-image'];
		iconList.png = ['far', 'file-image'];

		if (iconList.hasOwnProperty(extension)) {
			return iconList[extension];
		} else {
			return iconList.default;
		}

	}

	/**
	 * dismissLoader()
	 *
	 * Loader entfernen
	 */
	async dismissLoader() {
		try {
			this.loader.dismiss();
			this.loader = null;
		} catch (e) {
			console.log('dismissToast: ', e);
		}
	}

	/**
	 * openObjectAlert()
	 *
	 * Öffnet eine Dialog zum Object (z.B. Schriftstück), welcher drei Optionen für den Benutzer anbietet:
	 * - Anzeigen - showDetail()
	 * - Aktualisieren - updateObject()
	 * - Entfernen - removeObject()
	 *
	 * @param schriftgut
	 * @param schriftgutItem
	 * @param index
	 */
	async openObjectAlert(schriftgut: any, schriftgutItem: string, index: number): Promise<void> {

		this.alert = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00070,
			subHeader: this.userService.setTitle(schriftgut[schriftgutItem][0].details.Text),
			buttons: [
				{
					text: ALERT_TXT.buttons.str00180,
					handler: () => {
						this.showDetail(schriftgut[schriftgutItem][0]);
					}
				}, {
					text: ALERT_TXT.buttons.str00190,
					handler: () => {
						this.updateObject(schriftgutItem, schriftgut[schriftgutItem][0], index);
					}
				}, {
					text: ALERT_TXT.buttons.str00200,
					handler: () => {
						this.removeObject(schriftgut[schriftgutItem][0].path, schriftgut[schriftgutItem][0].objid, index, schriftgut);
					}
				}, {
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}
			]
		});

		await this.alert.present();

	}


	/**
	 * openFileAlert()
	 *
	 * Öffnet eine Dialog zur Datei, welcher drei Optionen für den Benutzer anbietet:
	 * - Anzeigen - showDetail()
	 * - Bearebiten - openFileForEdit()
	 * - Entfernen - deleteFile()
	 *
	 * @param file
	 */
	async openFileAlert(file: any) {

		this.alert = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00080,
			subHeader: file.name,
			message: ALERT_TXT.message.str00010 + ': ' + this.userService.setTitle(file.details.Text),
			buttons: [
				{
					text: ALERT_TXT.buttons.str00180,
					handler: () => {
						this.viewFile(file);
					}
				}, {
					text: ALERT_TXT.buttons.str00210,
					handler: () => {
						this.openFileForEdit(file);
					}
				}, {
					text: ALERT_TXT.buttons.str00200,
					handler: () => {
						this.deleteFile(file);
					}
				}, {
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}
			]
		});

		await this.alert.present();
	}


}
